import React, {Fragment} from "react";
import useListboxFetch from "root/ReactHookForm/ui/useListboxFetch";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import {CommonDropdown} from "root/ReactHookForm/ui/CommonDropdown";

const DropdownLetterboxDecisions = ( { control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, team_id, organisation_id, filter } ) =>
{
    const url = '/letterbox/decisions';

    const fields = { url: url, keyFieldName: 'letterbox_decision_type_id', labelFieldName: 'letterbox_decision_type' }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownLetterboxDecisions;

